export default __webpack_public_path__ + "static/media/bag4.41d7499e.jfif";